import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useForm } from "react-hook-form";
import { PaziaFormButton } from "components/atoms";
import { PaziaInput } from "components/atoms";
import { PlaceTagApi } from "api/placeTagsApi";

interface CreatePlaceTagFormProps {
  onSubmit: (data: PlaceTagFormValues) => void;
  data?: PlaceTagApi;
}

export const PlaceTagForm = ({ onSubmit, data }: CreatePlaceTagFormProps) => {
  const methods = useForm<PlaceTagFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: data?.name,
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <PaziaInput name={PLACE_FORM_NAME.NAME} label="Nazwa" type="text" />
        <div className="pt-4">
          <PaziaFormButton title="Zapisz" type="primary" />
        </div>
      </form>
    </FormProvider>
  );
};

const PLACE_FORM_NAME = {
  NAME: "name",
} as const;

const schema = yup
  .object({
    [PLACE_FORM_NAME.NAME]: yup.string().required(),
  })
  .required();

export type PlaceTagFormValues = yup.InferType<typeof schema>;
